/**
 * Extrai uma mensagem legível de um erro de resposta da API (DRF ou formato interno).
 * Cobre os formatos mais comuns:
 *   { detail: "..." }
 *   { error: { message: "..." } }
 *   { non_field_errors: ["..."] }
 *   { field: ["..."] }  — retorna a primeira mensagem encontrada
 */
export function extractApiError(err: any, fallback = "Ocorreu um erro. Tente novamente."): string {
  const data = err?.response?.data;
  if (!data) return fallback;

  // String limpa (não parece objeto Python/JSON raw)
  if (typeof data === "string") {
    if (data.startsWith("{") || data.startsWith("[") || data.includes("ErrorDetail")) return fallback;
    return data;
  }

  if (data.error?.message) return data.error.message;
  if (typeof data.detail === "string") return data.detail;

  if (Array.isArray(data.non_field_errors) && data.non_field_errors.length) {
    const first = data.non_field_errors[0];
    return typeof first === "string" ? first : first?.string ?? fallback;
  }

  // Primeiro campo com array de erros
  for (const key of Object.keys(data)) {
    const val = data[key];
    if (Array.isArray(val) && val.length) {
      const first = val[0];
      return typeof first === "string" ? first : first?.string ?? fallback;
    }
  }

  return fallback;
}
